// extracted by mini-css-extract-plugin
export default {"mainCont":"AuthenticationLoader_mainCont__PSwuc","elementsCont":"AuthenticationLoader_elementsCont__NqVN0"};